import Bera from "./Bera";

function App() {
  return (
    <div className="App">
     <Bera/>
    </div>
  );
}

export default App;
